// Copyright (c) 2016 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const Facets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet,
    partReturnStatusesFacet: t.struct({
        allowedStatuses: t.Array,
        isInitialLoad: t.Boolean,
        selectedStatuses: t.Array
    }),
    requestDateFacet: t.struct({
        dateFormat: t.String,
        dateRange: DateRange,
        isInitialLoad: t.Boolean,
        maxDate: t.maybe(t.Number),
        minDate: t.maybe(t.Number)
    }),
    requestTypes: t.struct({
        allowedTypes: t.list(KeyValuePair, 'AllowedRequestTypes'),
        selectedTypes: t.list(KeyValuePair, 'SelectedRequestTypes')
    })
}, 'Facets');

export const getDefaultState = () =>
    new Facets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState(),
        partReturnStatusesFacet: {
            allowedStatuses: [],
            isInitialLoad: true,
            selectedStatuses: [{
                key: '1'
            }]
        },
        requestDateFacet: {
            dateFormat: 'MM-DD-YYYY',
            dateRange: {
                from: null,
                to: null
            },
            isInitialLoad: true
        },
        requestTypes: {
            allowedTypes: [],
            selectedTypes: []
        }
    });

export default Facets;



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/state/facets.js